import CompletableChecklist from "@coworker/apprestructured/src/task-management/components/CompletableChecklist/CompletableChecklist";
import ChecklistItem from "@coworker/apprestructured/src/task-management/types/ChecklistItem";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { useCallback } from "react";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type CompletableChecklistViewerFragmentConfigProps = {
  title: string;
  field: string;
};

type CompletableChecklistViewerFragmentProps = {
  configProps: CompletableChecklistViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function CompletableChecklistViewerFragment({
  configProps,
  commonProps,
}: CompletableChecklistViewerFragmentProps) {
  const { field, title } = configProps;
  const { blockInput, task, onTaskChange } = commonProps;
  const items = getTypedValue<ChecklistItem[]>(getByPath(task, field));
  const handleItemsChange = useCallback(
    (newItems: ChecklistItem[]) => {
      onTaskChange(setByPath(field, newItems));
    },
    [field, onTaskChange]
  );

  const { t } = useTranslation();

  if (isLoading(items)) {
    return null;
  }

  return (
    <CompletableChecklist
      items={items}
      onItemsChange={handleItemsChange}
      label={t(title)}
      disabled={blockInput}
    />
  );
}

export default CompletableChecklistViewerFragment;
